const config = {
    bearerToken: 'e4b285325d18f062cc2b693140baf8048b36459b3920b38478b404359efa5299202a6b131e9cd1f80723084bf2e935ff9ef85dabe867faf31aa71df5ed73635709e473bce47798cdfc6baaf33ac1e41768df7b9d3fb43dbbca50c926d4a5cf6cce3c91e7c19b0ad1176fba5509dac8cad70469d5618d05cfba59b24224b2c98c'
  };
  
  export default config;